import { useGetCompanyAndUserInfoQuery } from 'common/queries';
import { Helmet, LoadingIndicator } from 'components';
import PowerBIDashboard from 'components/PoweBI/PowerBIDashboard';
import { useCustomTranslation } from 'helpers/translationHelper';
import React from 'react';

import ManagerDashboard from './components/ManagerDashboard';
import SuperadminDashboard from './components/SuperadminDashboard';

interface Props {}

const DashboardPage: React.FC<Props> = (): React.ReactElement => {
  const { t } = useCustomTranslation();

  const companyAndUserQuery = useGetCompanyAndUserInfoQuery();
  const user = companyAndUserQuery.data?.user;

  if (!user) {
    return <LoadingIndicator />;
  }

  // if (appUser && appUser.isSuperAdmin) {
  //   return <Redirect to="/admin/companies" push />;
  // }

  // if (appUser) {
  //   return <Redirect to="/schedule" push />;
  // }

  if (user.isSuperAdmin) {
    return (
      <>
        <Helmet title={t('mainMenu.dashboard')} />
        <SuperadminDashboard />
      </>
    );
  }

  return (
    <>
      <Helmet title={t('mainMenu.dashboard')} />
      {companyAndUserQuery.data?.company.isReportingEnabled ? (
        <PowerBIDashboard />
      ) : (
        // TODO: in future there will be a technician dashboard
        <ManagerDashboard />
      )}
    </>
  );
};

export default DashboardPage;
